// Sok helyen használjuk, ezért kell külön komponensnek lennie

import './ButtonContainer.css'

class ButtonContainer extends HTMLElement {}

customElements.define('a-button-container', ButtonContainer)
